import React from 'react';
import { usePathname } from '@framework/next/navigation';
import { footerConfig } from './footerConfig';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import StickyFooter from '@framework/ui/Organisms/StickyFooter';
import styles from './footer.module.scss';

interface IProps {
  tenant: DataroomTenant,
}

const Footer = ({ tenant }: IProps) => (
  <StickyFooter
    contentClassName={ styles.Content }
    config={ footerConfig(tenant, usePathname()) }
  />
);

export default Footer;
